import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { SVGComponent } from "@typings/svg-component";
import { colors } from "@ui/style/colors";
import { Button } from "primereact/button";
import React from "react";

interface ButtonIconProps {
	icon: SVGComponent;
	size?: "default" | "condensed";
	onClick: () => void;
	disabled?: boolean;
	testId?: string;
}

export const ButtonIcon = ({
	icon: Icon,
	size = "default",
	onClick,
	disabled,
	testId,
}: ButtonIconProps): JSX.Element => (
	<StyledButton
		className="p-button-rounded p-button-text p-button-icon-only"
		onClick={onClick}
		disabled={disabled}
		condensed={size === "condensed"}
		data-test={testId}
	>
		<Icon width={24} height={24} color={disabled ? colors.grey50 : colors.black} />
	</StyledButton>
);

const StyledButton = styled(Button)<{ condensed: boolean }>`
	&.p-button:disabled:not(.p-button-loading) {
		background-color: unset;
	}

	${({ condensed }) =>
		condensed
			? css`
					width: 32px !important;
					height: 32px !important;
				`
			: ""}
`;
